import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Paginator } from '@app/classes';
import { hasHttpStatus } from '@app/functions/type-guards';
import { AuthService } from '@app/services';
import { Drive } from '@models/documents/directory/drive.model';
import { Node } from '@models/documents/directory/node.model';
import { TableMessageService } from '@table/classes/table-message.service';
import { Table } from '@table/classes/table.class';
import { TableMessagesEnum } from '@table/enums/table-messages.enum';
import { MenuColumnItem } from '@table/interfaces/menu-column-item.interface';
import { AssignmentColumn, ModifiedAtColumn, NameColumn, SourceTypeColumn } from './columns';

@Injectable()
export class DocumentNodesIndexTable extends Table {
    links = false;
    unnavigableLink = true;

    showMenuColumnOptions = true;

    node: Node | undefined;
    parentDrive: Drive | undefined;

    bulkSelect = true;

    allowDragAndDrop = true;
    showGrippyOnCheckbox = true;

    defaultSortProperty = 'default';
    private pathRoot: string = 'documents-v2';

    private _documentMenuColumnOptions: MenuColumnItem[] = [
        {
            label: 'table.document-nodes-index.download',
            event: 'download',
        },
        {
            label: 'table.document-nodes-index.delete',
            event: 'deleteDocument',
        },
    ];

    private _folderMenuColumnOptions: MenuColumnItem[] = [
        {
            label: 'table.document-nodes-index.rename',
            event: 'rename',
        },
        {
            label: 'table.document-nodes-index.delete',
            event: 'deleteFolder',
        },
    ];

    constructor(
        protected auth: AuthService,
        protected messages: TableMessageService,
        private router: Router
    ) {
        super(auth, messages);
    }

    reload(): void {
        this.messages.subject.next(TableMessagesEnum.CLEAR_SELECTION);
        this.paginator.loadData().catch((err: Error) => {
            if (hasHttpStatus(err.cause) && err.cause.httpStatus === 404) {
                this.router.navigate(['/' + this.pathRoot]);
            }
        });
    }

    getMenuColumnOptionsForRow(row: Node): MenuColumnItem[] {
        if (row.isFolder()) {
            return this._folderMenuColumnOptions;
        }
        return this._documentMenuColumnOptions;
    }

    loadNode(node: Node, parentDrive?: Drive): void {
        this.node = node;
        this.parentDrive = parentDrive;
        this.messages?.subject.next(TableMessagesEnum.CLEAR_SELECTION);
        this.boot();
    }

    setColumns(): void {
        if (this.parentDrive) {
            this.columns = [
                new NameColumn(this.parentDrive),
                new SourceTypeColumn(),
                new AssignmentColumn(),
                new ModifiedAtColumn(),
            ];
        }
    }

    // Load nodes based on the parent node
    setDataSource(): void {
        if (this.node) {
            this.paginator = new Paginator(Node.with('source.file').where('node', this.node.id));
        }
    }

    isRowValidDropZone(node: Node): boolean {
        return node.isFolder() || node.isDrive();
    }
}
